import { useIsLoggedIn } from '@emico-hooks/login-token'
import { Trans } from '@lingui/macro'
import * as React from 'react'

import styles from './EmptyState.module.scss'
import Button from '../../input/Button'
import Icon from '../../media/Icon'
import paths from '../../paths'
import Heading from '../../typography/Heading'
import Text from '../../typography/Text'
import CartEmptyIcon from '../CartEmptyIcon'

const EmptyState = () => {
    const isLoggedIn = useIsLoggedIn()

    return (
        <div className={styles.emptyState}>
            <Icon
                component={CartEmptyIcon}
                title="Cart"
                className={styles.icon}
            />

            <Heading element="h1" variant="h3" className={styles.heading}>
                <Trans id="cart.emptyState.heading">Your bag is empty</Trans>
            </Heading>

            {!isLoggedIn && (
                <>
                    <Text className={styles.explanation}>
                        <Trans id="cart.emptyState.explanation">
                            Sign in and check your previously added products.
                        </Trans>
                    </Text>

                    <Button
                        minWidth
                        variant="primary"
                        to={paths.login}
                        className={styles.button}
                        name="Sign in or register"
                        category="cart.emptyState.signIn"
                    >
                        <Trans id="cart.emptyState.signInButton">
                            Sign in or register
                        </Trans>
                    </Button>
                </>
            )}
            <Button
                minWidth
                variant="secondary"
                to={paths.home}
                className={styles.button}
                name="Continue shopping"
                category="cart.emptyState.continueShopping"
            >
                <Trans id="cart.emptyState.continueShoppingButton">
                    Continue shopping
                </Trans>
            </Button>
        </div>
    )
}

export default EmptyState
